<section class="row w-100 m-auto">
  <div class="col-1 header col" [ngClass]="{'openMenu':!isOpen}" *ngIf="isLogin">
    <app-second-header></app-second-header>
  </div>

  <div class="col-2 col header position-relative" [ngClass]="{'openMenu':isOpen}" *ngIf="isLogin">
    <app-header></app-header>
  </div>

  <div class="col position-relative overflow-auto">

    <ul class="nav d-flex justify-content-between align-items-center position-absolute py-1 w-100" *ngIf='!isLogin'>
      <a (click)="changeCurrentLang('ar')" (click)="isEnglish()" *ngIf="english"
        class="mx-3 mt-2 language px-3 matDropDown d-flex align-items-center" data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        العربية
      </a>

      <a (click)="changeCurrentLang('en')" (click)="isArabic()" *ngIf="arabic"
        class="mx-3 mt-2 language px-3 matDropDown d-flex align-items-center" data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        English
      </a>
    </ul>

    <div class="header" *ngIf='isLogin'>
      <ul class="nav d-flex justify-content-between align-items-center position-absolute py-1 w-100">
        <div class="d-flex">
          <div class="px-3">
            <input type="checkbox" id="check" (change)="open($event)">
            <label for="check">
              <img src="assets/images/menu.png" alt="logo" class="check">
            </label>
          </div>
          <a (click)="changeCurrentLang('ar')" (click)="isEnglish()" *ngIf="english"
            class="mx-3 mt-2 language px-3 matDropDown d-flex align-items-center" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            العربية
          </a>

          <a (click)="changeCurrentLang('en')" (click)="isArabic()" *ngIf="arabic"
            class="mx-3 mt-2 language px-3 matDropDown d-flex align-items-center" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            English
          </a>
        </div>
        <div class="px-3 d-flex align-items-center">
          <button mat-button [matMenuTriggerFor]="menu">
            <p class="pt-3 mx-2">alfa care<span> <img src="assets/images/Alfa logo.png" alt="ALFA"
                  class="imge-user mx-2"></span></p>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item>
              <a mat-menu-item class="login mx-2" (click)='openDialog()'>{{"Register.logout"
                | translate}} <img src="assets/images/Mask Group 56_2022-10-20/Mask Group 56.png" class="w-25"
                  alt="ALFA"></a>
            </button>
          </mat-menu>
        </div>
      </ul>
    </div>

    <!-- small screen -->
    <div class="openDropMenu" *ngIf='isLogin'>
      <app-small-header></app-small-header>
    </div>
    <!-- end small screen -->

    <router-outlet></router-outlet>
    
  </div>

</section>

<div class="full-Page d-flex justify-content-center align-items-center" *ngIf="spinner">
  <div class="lds-dual-ring"></div>
</div>